/* AB community wall: moving rows (homepage, product, set pages) + Wall of Fame page.
   Data (built by build_wall_json.py, best first): {s: stories, c: comments, d: private messages}, no totals.
   Item keys: t = c | d | s, m = "YYYY-MM", n = name, a = avatar url, x = text, l = Instagram link, k = topic,
   p = poster url, v = video url (silent copies, no music), i = image url, w = wall grid only (not in moving rows). Private messages never carry a name or photo. */
(function () {
  if (window.abWallInit) return;
  window.abWallInit = true;
  var MONTHS = ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
  var LABEL = { c: 'Kommentar', d: 'Nachricht an @authentic.blonde', s: 'Story' };
  var reduceQ = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)'), reduce = !!(reduceQ && reduceQ.matches);
  var keys = false;  // last input was the keyboard: only then does focus hold the rows or show a focus ring
  document.addEventListener('keydown', function (e) { if (/^(Tab|Enter| |Arrow)/.test(e.key)) { keys = true; document.documentElement.classList.add('abw-keys'); } }, true);
  document.addEventListener('pointerdown', function () { keys = false; document.documentElement.classList.remove('abw-keys'); }, true);

  function when(m) { var p = (m || '').split('-'); return p.length === 2 ? MONTHS[+p[1] - 1] + ' ' + p[0] : ''; }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }

  /* videos play only while visible, muted, so a page with many stories stays light */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { var v = e.target; if (e.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
  }, { rootMargin: '100px' }) : null;

  function story(it) {
    var b = el('button', 'abw-story'); b.type = 'button';
    b.setAttribute('aria-label', (it.v ? 'Video-Story' : 'Story') + ' von @' + it.n + ' öffnen');
    if (it.v && io) {
      var v = el('video'); v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
      v.preload = 'none'; v.poster = sized(it.p, 360); v.src = it.v; b.appendChild(v); io.observe(v);
    } else {
      var img = el('img'); img.src = sized(it.p || it.i, 360); img.alt = 'Story von @' + it.n; img.loading = 'lazy'; b.appendChild(img);
    }
    if (it.v) b.appendChild(el('span', 'abw-play'));
    b.appendChild(el('span', 'abw-story-name', '@' + it.n));
    b.addEventListener('click', function () { modal()._open(it, b); });
    return b;
  }

  /* inRow: a card in a moving row opens in full on tap, so it carries no link of its own (no link inside a button) */
  function card(it, inRow) {
    if (it.t === 's') return story(it);
    var c = el('article', 'abw-card abw-card--' + it.t);
    var head = el('div', 'abw-head');
    var av = el('span', 'abw-av' + (it.t === 'd' ? ' abw-av--private' : ''));
    if (it.t === 'c' && it.a) { var ai = el('img'); ai.src = sized(it.a, 96); ai.alt = ''; ai.loading = 'lazy'; av.appendChild(ai); }
    else if (it.t === 'c' && it.n) { av.textContent = it.n.charAt(0).toUpperCase(); }
    head.appendChild(av);
    head.appendChild(el('span', 'abw-name', it.t === 'd' ? 'Private Nachricht' : '@' + it.n));
    c.appendChild(head);
    c.appendChild(el('p', 'abw-text', it.x));
    var foot = el('div', 'abw-foot', LABEL[it.t] + ' · ' + when(it.m));
    if (it.t === 'c' && !inRow && /^https:\/\/www\.instagram\.com\//.test(it.l || '')) {
      var a = el('a', 'abw-link', 'Auf Instagram ansehen'); a.href = it.l; a.target = '_blank'; a.rel = 'noopener';
      foot.appendChild(document.createTextNode(' · ')); foot.appendChild(a);
    }
    c.appendChild(foot);
    return c;
  }

  function modal() {
    var m = document.getElementById('abw-modal');
    if (m) return m;
    m = el('div', 'abw-modal'); m.id = 'abw-modal'; m.hidden = true;
    m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true'); m.setAttribute('aria-label', 'Beitrag');
    var x = el('button', 'abw-close', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Schließen');
    var box = el('div', 'abw-modal-box'); var cap = el('p', 'abw-modal-name');
    m.appendChild(x); m.appendChild(box); m.appendChild(cap); document.body.appendChild(m);
    var stilled = [];  // page parts made inert while the pop-up is open, so Tab stays inside it
    function close() {
      m.hidden = true; box.innerHTML = ''; document.documentElement.classList.remove('abw-lock');
      stilled.forEach(function (n) { n.inert = false; }); stilled = [];
      if (m._from) m._from.focus({ preventScroll: true });  // no jump back on close (iOS scrolled the page)
    }
    x.addEventListener('click', close);
    m.addEventListener('click', function (e) { if (e.target === m) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !m.hidden) close(); });
    m._open = function (it, from) {
      m._from = from || null;  // focus goes back to the card or story that opened it
      box.innerHTML = ''; box.classList.remove('abw-modal-box--text');
      if (it.t !== 's') {
        box.appendChild(card(it)); box.classList.add('abw-modal-box--text');
      } else if (it.v) {
        var v = el('video'); v.muted = true; v.preload = 'metadata'; v.src = it.v; v.poster = it.p || ''; v.controls = true;
        v.playsInline = true; v.setAttribute('playsinline', ''); v.autoplay = true;
        box.appendChild(v);
      } else { var i = el('img'); i.src = it.i; i.alt = 'Story von @' + it.n; box.appendChild(i); }
      cap.textContent = it.t === 's' ? '@' + it.n + ' · ' + when(it.m) : '';
      m.hidden = false; document.documentElement.classList.add('abw-lock');
      [].forEach.call(document.body.children, function (n) { if (n !== m && !n.inert) { n.inert = true; stilled.push(n); } });
      x.focus();
    };
    return m;
  }

  function load(root) {
    return fetch(root.getAttribute('data-src')).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }

  /* moving rows: each row holds its items twice so the CSS loop is seamless; topic items (product pages) go first */
  function rows(root, data) {
    var topic = root.getAttribute('data-topic'), n = +root.getAttribute('data-per-row') || 18;
    var paused = false, kbd = false, all = [];  // rolling state, see sync() and swipe() below
    function pick(list) {
      if (!topic) return list.slice(0, n);
      return list.filter(function (it) { return it.k === topic; }).concat(list.filter(function (it) { return it.k !== topic; })).slice(0, n);
    }
    root.querySelectorAll('[data-abw-track]').forEach(function (track) {
      var off = +track.getAttribute('data-offset') || 0;
      var items = pick((data[track.getAttribute('data-abw-track')] || []).filter(function (it) { return !it.w; }).slice(off));
      if (!items.length) { track.parentNode.hidden = true; return; }
      for (var round = 0; round < (reduce ? 1 : 2); round++) items.forEach(function (it) {  // reduced motion: no loop, one round to scroll by hand
        var c = card(it, true);
        if (it.t !== 's') {  // rows cut long texts: tap or Enter opens the whole card
          c.classList.add('abw-card--open'); c.setAttribute('role', 'button'); c.tabIndex = 0;
          c.appendChild(el('span', 'abw-sr', 'Ganzen Text lesen'));
          c.addEventListener('click', function () { modal()._open(it, c); });
          c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); modal()._open(it, c); } });
        }
        if (round) { c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; }
        track.appendChild(c);
      });
      track.style.setProperty('--abw-dur', Math.max(30, items.length * (+track.getAttribute('data-sec') || 5)) + 's');
      if (!reduce) swipe(track);
    });
    root.addEventListener('focusin', function (e) { kbd = keys && !!e.target.closest('.abw-mq-row'); sync(); });
    root.addEventListener('focusout', function () { var m = document.getElementById('abw-modal'); if (m && !m.hidden) return; kbd = false; sync(); });
    if (reduceQ && reduceQ.addEventListener) reduceQ.addEventListener('change', sync);  // reduce motion switched on during the visit
    var btn = root.querySelector('[data-abw-pause]');
    if (btn && reduce) btn.hidden = true;
    else if (btn) btn.addEventListener('click', function () {
      paused = root.classList.toggle('is-paused'); btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.textContent = paused ? 'Bewegung starten' : 'Bewegung anhalten'; sync();
    });

    /* Rolling is driven through the Web Animations API, not CSS play-state: a row rolls unless the pause button,
       keyboard focus, the mouse (devices with hover only) or a finger holds it. A finger or mouse drag moves the loop
       with it (currentTime), it keeps rolling 0.6 s after letting go, and a drag never opens a card. */
    function sync() {
      all.forEach(function (r) {
        if (reduceQ && reduceQ.matches) { if (r.a) r.a.cancel(); r.a = null; return; }
        r.a = r.a || (r.track.getAnimations && r.track.getAnimations()[0]);
        if (r.a) { if (paused || kbd || r.hover || r.drag) r.a.pause(); else r.a.play(); }
      });
    }
    function swipe(track) {
      var row = track.parentNode, r = { track: track }, x0 = null, t0 = 0, moved = false, timer, kind;
      var dir = track.getAttribute('data-dir') === 'right' ? -1 : 1;
      all.push(r);
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        row.addEventListener('mouseenter', function () { r.hover = true; sync(); });
        row.addEventListener('mouseleave', function () { r.hover = false; sync(); });
      }
      row.addEventListener('pointerdown', function (e) {
        if (!e.isPrimary) return;  // a second finger does not move the row
        clearTimeout(timer); r.drag = true; moved = false; kind = e.pointerType; sync();
        x0 = r.a ? e.clientX : null; t0 = r.a ? r.a.currentTime : 0;
      });
      row.addEventListener('pointermove', function (e) {
        if (x0 === null || !e.isPrimary || (kind === 'mouse' && !e.buttons)) return;
        var dx = e.clientX - x0;
        if (!moved && Math.abs(dx) > 6) { moved = true; try { row.setPointerCapture(e.pointerId); } catch (err) {} }
        if (!moved) return;
        var D = r.a.effect.getComputedTiming().duration, t = t0 - dir * dx * D / (track.scrollWidth / 2);  // one loop = half the track
        r.a.currentTime = ((t % D) + D) % D;
      });
      function up(e) { if (e && e.isPrimary === false) return; x0 = null; clearTimeout(timer); timer = setTimeout(function () { r.drag = false; sync(); }, 600); }
      row.addEventListener('pointerup', up);
      row.addEventListener('pointercancel', up);
      row.addEventListener('pointerleave', up);  // mouse let go outside the row before the drag took hold
      row.addEventListener('contextmenu', up);  // right-click: the menu swallows pointerup
      row.addEventListener('click', function (e) { if (moved && kind !== 'touch') { e.stopPropagation(); e.preventDefault(); } moved = false; }, true);  // a touch drag sends no click, a wobbly tap still opens
      row.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }

  function marquee(root) { load(root).then(function (data) { rows(root, data); }).catch(function () { root.hidden = true; }); }

  /* Wall of Fame page: same moving rows on top, then one mixed wall (two text cards, one story), best first.
     Endless: more cards load as the visitor nears the end and stop once all are shown, so the footer stays reachable.
     Each card goes into the shortest column, so loading more never moves the cards someone is reading. */
  function wall(root) {
    var grid = root.querySelector('[data-abw-grid]'), more = root.querySelector('[data-abw-more]');
    var tabs = root.querySelectorAll('[data-abw-filter]'), STEP = 30, list = [], shown = 0, mixed = [], data, cols = [], nodes = [];
    var end = el('div'); grid.parentNode.insertBefore(end, more);
    var feed = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      if (es[0].isIntersecting && shown < list.length) { render(false); check(); }
    }, { rootMargin: '0px 0px 800px 0px' }) : null;
    function check() { if (feed) { feed.unobserve(end); feed.observe(end); } }  // a fresh look: keeps filling while the end is still near
    function ncols() { return window.innerWidth > 1100 ? 4 : window.innerWidth > 760 ? 3 : 2; }  // same breakpoints as ab-wall.css
    function place(n) { cols.reduce(function (a, b) { return b.offsetHeight < a.offsetHeight ? b : a; }).appendChild(n); }
    function layout() {
      grid.innerHTML = ''; cols = [];
      for (var i = ncols(); i > 0; i--) cols.push(grid.appendChild(el('div', 'abw-col')));
      nodes.forEach(place);
    }
    function render(reset) {
      if (reset) { nodes = []; shown = 0; layout(); }
      list.slice(shown, shown + STEP).forEach(function (it) { var n = card(it); nodes.push(n); place(n); });
      shown = Math.min(shown + STEP, list.length); more.hidden = !!feed || shown >= list.length;  // button only where endless loading cannot run
    }
    function filter(f) {
      list = f === 'all' ? mixed : data[f];
      tabs.forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-abw-filter') === f ? 'true' : 'false'); });
      render(true); check();
    }
    load(root).then(function (d) {
      data = d; rows(root, d);
      var texts = [], ci = 0, di = 0, si = 0, ti = 0;
      while (ci < d.c.length || di < d.d.length) {  // every 4th text card is a private message
        texts.push((texts.length % 4 === 3 && di < d.d.length) || ci >= d.c.length ? d.d[di++] : d.c[ci++]);
      }
      while (ti < texts.length || si < d.s.length) {  // two text cards, then one story
        if (ti < texts.length) mixed.push(texts[ti++]);
        if (ti < texts.length) mixed.push(texts[ti++]);
        if (si < d.s.length) mixed.push(d.s[si++]);
      }
      tabs.forEach(function (t) {
        var f = t.getAttribute('data-abw-filter');
        t.addEventListener('click', function () { filter(f); });
      });
      more.addEventListener('click', function () { render(false); });
      window.addEventListener('resize', function () { if (cols.length !== ncols()) layout(); });
      filter('all');
    }).catch(function () { root.hidden = true; });
  }

  function boot() {
    document.querySelectorAll('[data-abw-wall]:not([data-abw-ready])').forEach(function (r) { r.setAttribute('data-abw-ready', ''); wall(r); });
    document.querySelectorAll('[data-abw-marquee]:not([data-abw-ready])').forEach(function (r) { r.setAttribute('data-abw-ready', ''); marquee(r); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);  // theme editor re-renders a section after a settings change
})();
